import { Boxes, Clock, TriangleAlert, Inbox } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { SectionShell, SectionHead, FeatureCard } from "@/components/site/Primitives";

const CARDS = [
  { icon: Boxes, tint: "blue", title: "Fragmented Commercial Information", copy: "Contractual, operational, financial and market information remains separated across tools, documents and teams." },
  { icon: Clock, tint: "gold", title: "Decision Latency", copy: "Executives and commercial teams spend valuable time gathering and reconciling information before acting." },
  { icon: TriangleAlert, tint: "gold", title: "Hidden Commercial Exposure", copy: "Contractual, financial, counterparty and operational implications are often discovered too late." },
  { icon: Inbox, tint: "purple", title: "Lost Institutional Intelligence", copy: "Commercial reasoning remains inside inboxes, documents and individual experience rather than becoming reusable enterprise intelligence." },
];

export function Problem() {
  return (
    <SectionShell id="problem" tone="white">
      <div className="max-w-3xl">
        <SectionHead
          label="The Problem"
          labelColor="gold"
          title="Commercial decisions are critical. The information behind them is fragmented."
          intro="Maritime companies manage high-value commercial decisions across contracts, operations, finance, counterparties, markets and regulation. Critical information exists across disconnected systems, documents and workflows, forcing executives to assemble context before they can begin making decisions."
        />
      </div>

      <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {CARDS.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.07}>
            <FeatureCard icon={c.icon} tint={c.tint} title={c.title}>
              {c.copy}
            </FeatureCard>
          </Reveal>
        ))}
      </div>

      <Reveal>
        <p className="mt-14 max-w-[960px] font-display text-xl leading-relaxed text-natsu-navy sm:text-2xl">
          The problem is no longer a lack of data.
          <br className="hidden lg:inline" />{" "}
          <span className="lg:block">
            It is the inability to transform fragmented information into trusted commercial intelligence.
          </span>
        </p>
      </Reveal>
    </SectionShell>
  );
}
